import { render, staticRenderFns } from "./LabInfoManagement.vue?vue&type=template&id=cd4c0250&scoped=true&"
import script from "./LabInfoManagement.vue?vue&type=script&lang=js&"
export * from "./LabInfoManagement.vue?vue&type=script&lang=js&"
import style0 from "./LabInfoManagement.vue?vue&type=style&index=0&id=cd4c0250&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4c0250",
  null
  
)

export default component.exports